import styled, { css } from 'styled-components';

interface ContentImageParams {
	imageWH: string;
}

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 1.5rem; // 1.5rem = 24px
	border: 0.0625rem solid #d1d2dc; // 0.0625rem = 1px
	border-radius: 0.5rem; // 0.5rem = 8px
	margin: 0.5rem 0;
	cursor: pointer;

	:hover {
		box-shadow: 0 0 0.1875rem rgba(0, 0, 0, 0.5); // 0.1875rem = 3px
		transition: box-shadow 0.9s,
	}
`;

export const ContentData = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ContentImage = styled.div<ContentImageParams>`
	display: flex;
	width: auto;
	height: auto;

	${props => 
		css`
			max-width: ${props.imageWH};
			max-height: ${props.imageWH};
		`}
	
`;

export const TextName = styled.span`
	color: #353646;
	font-weight: 500;
	text-transform: capitalize;
`;

export const TextDescription = styled.span`
	font-size: 0.9375rem; // 0.9375rem = 15px
	color: #616480;
	// font-weight: 500;
	text-transform: capitalize;
`;

export const TextValueCod = styled.span`
	font-size: 0.9375rem; // 0.9375rem = 15px
	font-weight: 500;
	color: #1f2029;
	text-transform: capitalize;
`;

